<template>
  <div class="row mt-1 m-0 mb-0 pb-0">
    <div class="table-responsive mx-0 px-1 mb-0 pb-0">
      <div ref="visibleElementLeague">
        <div v-for="event in league_events">
          <template v-if="rank_event_id == event.grade">
          <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover text-center mt-2 mb-1" style="max-width: 430px; margin: 0 auto;">
            <thead>
              <template v-if="user && user.email">
                <tr data-bs-toggle="modal" data-bs-target="#inputRankResultModal" @click="openEditRankForm(event.event_id)">
                  <th scope="col" class="rank-column"><font-awesome-icon :icon="['fas', 'trophy']" style="color: #808080;" /></th>
                  <th scope="col" class="event-id-column" colspan="2" nowrap>{{ event.event_id }}</th>
                  <th scope="col" class="point-clmn">勝</th>
                  <th scope="col" class="point-clmn">負</th>
                  <th scope="col" class="point-clmn">得</th>
                  <th scope="col" class="point-clmn">失</th>
                </tr>
            </template>
            <template v-if="!user || !user.email">
                <tr>
                  <th scope="col" class="rank-column"><font-awesome-icon :icon="['fas', 'trophy']" style="color: #808080;" /></th>
                  <th scope="col" class="event-id-column" nowrap colspan="2">{{ event.event_id }}</th>
                  <th scope="col" class="point-clmn">勝</th>
                  <th scope="col" class="point-clmn">負</th>
                  <th scope="col" class="point-clmn">得</th>
                  <th scope="col" class="point-clmn">失</th>
                </tr>
            </template>

            </thead>
            <tbody>
                <!-- <tr v-for="entry in getLeagueEntries(event.event_id)" > -->
              <template v-for="entry in entries">
                <template v-if="entry.event_id == event.event_id">
                  <tr>
                    <td>{{ entry.rank }}</td>
                    <td colspan="2" style="text-align: left;"><TeamLabelComponent :teamId="entry.team_id_1"/>{{ entry.player_name_1 }}
                      <template v-if="entry.player_name_2 && entry.player_name_2 != ''">
                        ／<TeamLabelComponent :teamId="entry.team_id_2" v-if="entry.team_id_1 != entry.team_id_2"/>
                        {{ entry.player_name_2 }}
                      </template>
                    </td>
                    <td>{{ entry.won_count }}</td>
                    <td>{{ entry.lost_count }}</td>
                    <td>{{ entry.point_gained }}</td>
                    <td>{{ entry.point_lost }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- <AffiliateComponent /> -->
  <div class="row mx-1">
    <table class="table text-center m-0 p-0">
      <tr><td class="m-0 p-0"><span style="font-size:10pt; color: #808080">[広告]</span></td></tr>
      <!-- <font-awesome-icon :icon="['fas', 'circle-info']" /> -->
    </table>
    <table class="text-center">
    <tr>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/2b20c9de.fc88cde4.2b20c9df.5f1aff53/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fshuttlestudio%2Fyonex-16810%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/2b20c9de.fc88cde4.2b20c9df.5f1aff53/?me_id=1407363&item_id=10002866&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fshuttlestudio%2Fcabinet%2Fgazou4%2Fjpn_16810_321.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/1f6e263f.f3098f1b.1f6e2640.85fb28e0/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fhimaraya%2F0000001186912%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/1f6e263f.f3098f1b.1f6e2640.85fb28e0/?me_id=1264309&item_id=10574776&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fhimaraya%2Fcabinet%2F0000001186e%2F0000001186912_r1_03.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/2612d83e.3ede2988.2612d83f.efbcaae2/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fkpi%2F10674j%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/2612d83e.3ede2988.2612d83f.efbcaae2/?me_id=1207677&item_id=10270090&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fkpi%2Fcabinet%2Fyonex-11%2F10674j-019.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
    </tr>
    <tr>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/2612d834.594607db.2612d835.f3a09023/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fchitosesports%2Ft-4200u%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/2612d834.594607db.2612d835.f3a09023/?me_id=1235592&item_id=10054320&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fchitosesports%2Fcabinet%2Fnomarl19%2Ft4200u-wht.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/1f6e263f.f3098f1b.1f6e2640.85fb28e0/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fhimaraya%2F0000001177594%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/1f6e263f.f3098f1b.1f6e2640.85fb28e0/?me_id=1264309&item_id=10571591&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fhimaraya%2Fcabinet%2F0000001177c%2F0000001177594_r1_02.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
      <td>
        <a href="https://hb.afl.rakuten.co.jp/ichiba/2612d834.594607db.2612d835.f3a09023/_RTLink87087?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Fchitosesports%2Ft-2515%2F&link_type=pict&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJwaWN0Iiwic2l6ZSI6IjgweDgwIiwibmFtIjoxLCJuYW1wIjoicmlnaHQiLCJjb20iOjEsImNvbXAiOiJkb3duIiwicHJpY2UiOjAsImJvciI6MSwiY29sIjoxLCJiYnRuIjoxLCJwcm9kIjowLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;"><img src="https://hbb.afl.rakuten.co.jp/hgb/2612d834.594607db.2612d835.f3a09023/?me_id=1235592&item_id=10050452&pc=https%3A%2F%2Fimage.rakuten.co.jp%2Fchitosesports%2Fcabinet%2Fnomarl8%2Ft2515-wht.jpg%3F_ex%3D80x80&s=80x80&t=pict" border="0" style="margin:2px" alt="" title=""></a>
      </td>
    </tr>
    </table>
  </div>
  <!-- ##### tournament ##### -->
  <div class="row mt-1 mx-0">
        <div class="table-responsive mx-0 px-1">
            

            <div ref="visibleElementTournament">
              <template v-for="tournament_event in tournament_events">
                <template v-if="rank_event_id == tournament_event.grade">
                  <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover text-center" style="max-width: 430px; margin: 0 auto;">
                    <thead>
                        <tr>
                            <th colspan="8" class="event-id-column">{{ tournament_event.event_id }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="tournament_match in tournament_matches">
                          <template v-if="tournament_match.event_id == tournament_event.event_id">
                            <tr v-if="isNewRound(tournament_match.round)">
                              <td colspan="8" style="text-align:left; background-color:#e9ecef; font-weight: 800;" class="my-0 pt-1 pb-0">&nbsp;{{ getRoundName(tournament_match.round) }}</td>
                            </tr>

                              <tr>
                                <td class="rank-column"><span style="color: darkgray">{{ tournament_match.match_no }}</span></td>
                                <template v-if="tournament_match.left_team_id_1">
                                  <td style="text-align:center; border-right: none;"><TeamLabelComponent :teamId="tournament_match.left_team_id_1"/><br><TeamLabelComponent :teamId="tournament_match.left_team_id_2" v-if="tournament_match.left_team_id_1 != tournament_match.left_team_id_2"/></td>
                                  <td style="text-align:left; border-left: none; border-right:none;">
                                      {{ tournament_match.left_player_name_1 }}<br>{{ tournament_match.left_player_name_2 }}
                                  </td>
                                </template>
                                <template v-else>
                                  <td colspan="2" style="text-align: center; border-right: none;">
                                    <span style="color:#d3d3d3;">{{ tournament_match.left_entry_id }}</span>
                                  </td>
                                </template>

                                <td style="padding-right:2px; margin:0; width:15px; border-left: none;">
                                  <span v-if="tournament_match.match_status === 'finished' && tournament_match.left_entry_id == tournament_match.winner_entry_id"><font-awesome-icon
                                      :icon="['fas', 'circle-check']" style="color: #32cd32" /></span>
                                </td>
                                <td style="width:50px" nowrap>
                                  <template v-if="tournament_match.match_status === 'finished'">
                                    <div class="score-display">
                                      <div v-if="tournament_match.left_game1_score && tournament_match.right_game1_score" class="score-line">
                                        <span class="left-score">{{ tournament_match.left_game1_score }}</span>
                                        <span class="score-separator">-</span>
                                        <span class="right-score">{{ tournament_match.right_game1_score }}</span>
                                      </div>
                                      <div v-if="tournament_match.left_game2_score && tournament_match.right_game2_score" class="score-line">
                                        <span class="left-score">{{ tournament_match.left_game2_score }}</span>
                                        <span class="score-separator">-</span>
                                        <span class="right-score">{{ tournament_match.right_game2_score }}</span>
                                      </div>
                                      <div v-if="tournament_match.left_game3_score && tournament_match.right_game3_score" class="score-line">
                                        <span class="left-score">{{ tournament_match.left_game3_score }}</span>
                                        <span class="score-separator">-</span>
                                        <span class="right-score">{{ tournament_match.right_game3_score }}</span>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="status-label" :class="getStatusClass(tournament_match)">
                                      {{ getStatusText(tournament_match) }}
                                    </div>
                                  </template>
                                </td>
                                <td style="padding-left:2px; margin:0; width:15px;border-right: none;">
                                  <span v-if="tournament_match.match_status === 'finished' && tournament_match.right_entry_id == tournament_match.winner_entry_id"><font-awesome-icon
                                      :icon="['fas', 'circle-check']" style="color: #32cd32" /></span>
                                </td>
                                <template v-if="tournament_match.right_team_id_1">
                                  <td style="text-align:center; border-left:none;  border-right: none;"><TeamLabelComponent :teamId="tournament_match.right_team_id_1"/><br><TeamLabelComponent :teamId="tournament_match.right_team_id_2" v-if="tournament_match.right_team_id_1 != tournament_match.right_team_id_2"/> </td>
                                  <td style="text-align:left; border-left: none;">
                                    {{ tournament_match.right_player_name_1 }}<br>{{ tournament_match.right_player_name_2 }}
                                  </td>
                                </template>
                                <template v-else>
                                  <td colspan="2" style="text-align:center; border-left:none;">
                                    <span style="color:#d3d3d3">{{ tournament_match.right_entry_id }}</span>
                                  </td>
                                </template>
                              </tr>
                          </template>
                          <template v-else>{{ resetPreviousRound() }}</template>
                        </template>
                      </tbody>
                  </table>
                </template>
              </template>
            </div>
        </div>
    </div>

  <!-- fab -->
  <div class="fab-container">
    <div class="btn-group btn-group-lg buttons" role="group" aria-label="radio toggle button group">
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio1" autocomplete="off" @click="showRankByGrade(6)" :checked="6 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-6', {'event_category': 'button','event_label': 'app-show-rank-grade-6'});">
      <label class="btn btn-outline-primary" for="vbtn-radio1">6</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio2" autocomplete="off" @click="showRankByGrade(5)" :checked="5 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-5', {'event_category': 'button','event_label': 'app-show-rank-grade-5'});">
      <label class="btn btn-outline-primary" for="vbtn-radio2">5</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio3" autocomplete="off" @click="showRankByGrade(4)" :checked="4 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-4', {'event_category': 'button','event_label': 'app-show-rank-grade-4'});">
      <label class="btn btn-outline-primary" for="vbtn-radio3">4</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio4" autocomplete="off" @click="showRankByGrade(3)" :checked="3 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-3', {'event_category': 'button','event_label': 'app-show-rank-grade-3'});">
      <label class="btn btn-outline-primary" for="vbtn-radio4">3</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio5" autocomplete="off" @click="showRankByGrade(2)" :checked="2 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-2', {'event_category': 'button','event_label': 'app-show-rank-grade-2'});">
      <label class="btn btn-outline-primary" for="vbtn-radio5">2</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio6" autocomplete="off" @click="showRankByGrade(1)" :checked="1 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-1', {'event_category': 'button','event_label': 'app-show-rank-grade-1'});">
      <label class="btn btn-outline-primary" for="vbtn-radio6">1</label>
    </div>
  </div>

  <div class="text-center" v-if="isLoading">
    <div class="spinner-border spinner" role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>

  <EditRankFormComponent :selectedEventId="selectedEventId" :selectedEventEntries="selectedEventEntries" @doReload="doReload"></EditRankFormComponent>
  <EditScoreFormComponent :selectedMatchKey="selectedMatchKey" :selectedMatch="selectedMatch" @doReload="doReload"></EditScoreFormComponent>
  <EditEntryFormComponent :selectedEntryId="selectedEntryId" :selectedEntry="selectedEntry" @doReload="doReload"></EditEntryFormComponent>
  <FooterComponent @reloadRank="reloadRank"></FooterComponent>
</template>
  
<script setup>
import EditRankFormComponent from '@/components/EditRankFormComponent.vue'
import EditScoreFormComponent from '@/components/EditScoreFormComponent.vue'
import EditEntryFormComponent from '@/components/EditEntryFormComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import AffiliateComponent from '@/components/AffiliateComponent.vue'
import TeamLabelComponent from '@/components/TeamLabelComponent.vue'
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ref as fbRef, getDatabase, child, get, query, equalTo, onValue, orderByChild, once} from "firebase/database"
import { getAuth } from "firebase/auth";
import { useElementVisibility } from '@vueuse/core'
const auth = getAuth();
const user = auth.currentUser;
// const role = ref();
const route = useRoute()
const db = getDatabase();
const dbRef = fbRef(db);
const isLoading = ref()
const entries = ref([])
const events = ref([])
const rank_event_id = ref();

const league_events = ref([])
const tournament_events = ref([])
const tournament_matches = ref([])

const selectedEventId = ref();
const selectedEventEntries = ref([]);

const selectedMatchKey = ref()
const selectedMatch = ref([]);

const selectedEntryId = ref();
const selectedEntry = ref([]);

const visibleElementTournament = ref(null)
const tournamentVisible = useElementVisibility(visibleElementTournament)

const visibleElementLeague = ref(null)
const leagueVisible = useElementVisibility(visibleElementLeague)

onMounted(() => {
  // user.getIdTokenResult()
  // .then((idTokenResult) => {
  //   role.value = idTokenResult.claims.role;
  // })
  rank_event_id.value = localStorage.getItem("rank_event_id");
  // console.log(rank_event_id)
  // console.log(rank_event_id.value)
  if (rank_event_id.value == null || rank_event_id.value == "") {
    rank_event_id.value = "6";
  }
  localStorage.setItem("rank_event_id", rank_event_id.value);

  const eventsRef = fbRef(db, '/2026-summer/events');
  disconnectEvents = onValue(query(eventsRef), (snapshot) => {
    tournament_events.value = snapshot.val();
    // console.log(JSON.stringify(tournament_events.value))
    tournament_events.value = Object.fromEntries(
      Object.entries(tournament_events.value)
        .filter(([key, value]) => "トーナメント" == value.method)
        .sort(function (a, b) {
          if ((a[0]) < (b[0])) { return -1 }
          if ((a[0]) > (b[0])) { return 1 }
        })
    );

    league_events.value = snapshot.val();
    league_events.value = Object.fromEntries(
      Object.entries(league_events.value)
        .filter(([key, value]) => "リーグ" == value.method)
        .sort(function (a, b) {
          if ((a[0]) < (b[0])) { return -1 }
          if ((a[0]) > (b[0])) { return 1 }
        })
    );
  });


});

let disconnectEvents = () => {}
let disconnectMatches = () => {}
let disconnectEntries = () => {}
watch(tournamentVisible, () => {
  if (tournamentVisible.value) {
    const matchesRef = fbRef(db, '/2026-summer/matches/');
    disconnectMatches = onValue(query(matchesRef), (snapshot) => {
      tournament_matches.value = snapshot.val();
      // console.log(JSON.stringify(tournament_matches.value))
      tournament_matches.value = Object.fromEntries(
        Object.entries(tournament_matches.value)
        .filter(([key, value]) => Object.keys(tournament_events.value).includes(value.event_id))
        .sort(function (a, b) {
          if (Number(a[1].round) < Number(b[1].round)) { return 1 }
          if (Number(a[1].round) > Number(b[1].round)) { return -1 }
          return 0;
        })
      );
    });

  } else {
    // disconnectEvents();
    disconnectMatches();
  }
})

watch(leagueVisible, () => {
  if (leagueVisible.value) {
    const entriesRef = fbRef(db, '/2026-summer/entries');
    disconnectEntries = onValue(query(entriesRef), (snapshot) => {
      
      entries.value = snapshot.val();
      localStorage.setItem('entries', JSON.stringify(entries.value))
      entries.value = Object.fromEntries(
        Object.entries(entries.value)
          .sort(function (a, b) {
            if ((a[0]) < (b[0])) { return -1 }
            if ((a[0]) > (b[0])) { return 1 }
          })
      );
    });
  } else {
    disconnectEntries();
  }
  
})

const doReload = () => {
  const event_id = localStorage.getItem("rank_event_id");
  showRankByGrade(event_id)
}

const reloadRank = async () => {
  isLoading.value = true;
  await fetchEntries();
  await fetchMatches();
  const event_id = localStorage.getItem("rank_event_id");
  showRankByGrade(event_id)
  isLoading.value = false;
}

const showRankByGrade = (event_id) => {
  rank_event_id.value = event_id;
  localStorage.setItem("rank_event_id", event_id);
}

const fetchEntries = async () => {
    await get(child(dbRef, '/2026-summer/entries')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('entries', JSON.stringify(snapshot.val()));
        } else {
            console.log('No entry data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchMatches = async () => {
    await get(child(dbRef, '/2026-summer/matches')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('matches', JSON.stringify(snapshot.val()));
        } else {
            console.log('No entry data')
        }
    }).catch((error) => {
        console.error(error)
    })
};

// const openEditScoreForm = (event_id, match_no) => {
//     selectedMatchKey.value = event_id + "-" + match_no;
//     get(child(dbRef, '/2026-summer/matches/' + event_id + "-" + match_no))
//     .then((snapshot) => {
//         if (snapshot.exists()) {
//             selectedMatch.value = snapshot.val();
//         } else {
//             console.warn("Not found - match:" + event_id + "-" + match_no)
//         }
//     });
// }

const getLeagueEntriesSortByBasicRule = (event_id) => {
  const allEntries = ref([]);
  allEntries.value = JSON.parse(localStorage.getItem("entries"));
  if (!allEntries.value) { return; }

  return Object.fromEntries(
    Object.entries(allEntries.value)
      .filter(([key, value]) => (event_id == value.event_id))
      .sort(function (a, b) {
        // if (a[1].rank < b[1].rank) { return -1 }
        // if (a[1].rank > b[1].rank) { return 1 }
        if (a[1].won_count < b[1].won_count) { return 1 }
        if (a[1].won_count > b[1].won_count) { return -1 }
        if (a[1].won_count+a[1].lost_count < b[1].won_count+b[1].lost_count) { return 1 }
        if (a[1].won_count+a[1].lost_count > b[1].won_count+b[1].lost_count) { return -1 }
        if (a[1].point_gained-a[1].point_lost < b[1].point_gained-b[1].point_lost) { return 1 }
        if (a[1].point_gained-a[1].point_lost > b[1].point_gained-b[1].point_lost) { return -1 }
        // if (a[1].point_lost < b[1].point_lost) { return -1 }
        // if (a[1].point_lost > b[1].point_lost) { return 1 }
        if (a[0] < b[0]) { return -1 }
        if (a[0] > b[0]) { return 1 }
        return 0
      })
  );
};

var previous_round = ref("");
const isNewRound = (current_round) => {
  if (previous_round == current_round) {
        return false;
    } else {
      previous_round = current_round;
        return true;
    }
}

const resetPreviousRound = () => {
  previous_round = "";
}

const openEditRankForm = (event_id) => {
  selectedEventId.value = event_id;
  selectedEventEntries.value = getLeagueEntriesSortByBasicRule(event_id);
}

const getRoundName = (round) => {
  if (round == 2) {
    return "決勝"
  } else if (round == 3) {
    return "3位決定戦"
  } else if (round == 4) {
    return "準決勝"
  } else if (round == 8) {
    return "準々決勝"
  } else {
    return "ラウンド" + round;
  }
}

const getStatusClass = (match) => {
  switch (match.match_status) {
    case 'called':
      return 'status-calling';
    case 'playing':
      return 'status-playing';
    case 'waiting':
      return 'status-waiting';
    case '':
      return '';
    default:
      return '';
  }
}

const getStatusText = (match) => {
  switch (match.match_status) {
    case 'called':
      return '招集中';
    case 'playing':
      return '試合中';
    case 'waiting':
      return match.start || '-';
    case '':
      return match.start || '-';
    default:
      return '';
  }
}
</script>
  
<style scoped>
#result-tbl {
  border-color: #dee2e6;
}

.rank-column {
  width: 25px;
}

th.rank-column {
  background-color: #e9ecef;
}

.event-id-column {
  background-color: #a3cfbb;
}

.point-clmn {
  width: 30px;
}

th.point-clmn {
  background-color: #e9ecef;
}

.team-column {
  border-right: none;
}

.player-column {
  text-align: left;
  border-left: none;
}

tr.boundary {
  border-top: 2px solid #198754;
}

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}

.fab-container {
  position: fixed;
  bottom: 80px;
  right: 20px;
  /* left: 50%; */
  cursor: pointer;
  z-index: 8;
}

.buttons {
  box-shadow: 5px 5px 5px #aaaaaa;
  background-color: #fff;
}

#vbtn-radio1 {
  background-color: white;
}

.score-display {
  font-size: 0.9rem;
  line-height: 1.2;
}

.score-line {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 2px;
  text-align: center;
}

.left-score {
  text-align: right;
}

.right-score {
  text-align: left;
}

.score-separator {
  padding: 0 2px;
}

.status-label {
  font-size: 0.8rem;
  padding: 2px 4px;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
}

.status-calling {
  background-color: #fff3cd;
  color: #856404;
}

.status-playing {
  background-color: #cce5ff;
  color: #004085;
}

.status-waiting {
  background-color: #f7f7f7;
  color: #a8a8a8;
}
</style>